import { useState, useEffect } from "react";



function Location({ location_url }){
    const [locationData, setLocationData] = useState([]);
    useEffect(() => {
        if (location_url) {
            fetch(location_url)
                .then(response => response.json())
                .then(data => setLocationData(data))
                .catch(error => console.error("Error fetching location data:", error));
        }
    }, [location_url]);

    return(
        <div>
            {location_url ?
                <div><p>Location Name: {locationData.name}</p>
                <p>Location Type: {locationData.type}</p>
                </div>
             : <p>No location data available.</p>}
        </div>
    )
}

export default Location;